"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function fromStatic(staticValue) {
    var promisified = Promise.resolve(staticValue);
    return function () { return promisified; };
}
exports.fromStatic = fromStatic;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZnJvbVN0YXRpYy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9mcm9tU3RhdGljLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUEsU0FBZ0IsVUFBVSxDQUFJLFdBQWM7SUFDMUMsSUFBTSxXQUFXLEdBQUcsT0FBTyxDQUFDLE9BQU8sQ0FBQyxXQUFXLENBQUMsQ0FBQztJQUNqRCxPQUFPLGNBQU0sT0FBQSxXQUFXLEVBQVgsQ0FBVyxDQUFDO0FBQzNCLENBQUM7QUFIRCxnQ0FHQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFByb3ZpZGVyIH0gZnJvbSBcIkBhd3Mtc2RrL3R5cGVzXCI7XG5cbmV4cG9ydCBmdW5jdGlvbiBmcm9tU3RhdGljPFQ+KHN0YXRpY1ZhbHVlOiBUKTogUHJvdmlkZXI8VD4ge1xuICBjb25zdCBwcm9taXNpZmllZCA9IFByb21pc2UucmVzb2x2ZShzdGF0aWNWYWx1ZSk7XG4gIHJldHVybiAoKSA9PiBwcm9taXNpZmllZDtcbn1cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/property-provider/build/fromStatic.js
// module id = iD1M
// module chunks = 0